import Vue from 'vue'
Vue.component('x-table', () => import('./table/index.vue'))
Vue.component('x-dialog', () => import('./dialog/naiveDialogInfo'));
Vue.component('x-select', () => import('./select/select'));
import Treeselect from '@riophae/vue-treeselect'
Vue.component('x-Treeselect', Treeselect);